import { ButtonTertiary, ButtonSecondary } from "components/Atoms/Button";
import React from "react";

interface Props {
  artist: server.dto.ArtistSmall
  selected: boolean
  onClick: () => void
}

const SelectableArtist = (props: Props) => {
  return <div>
    {props.selected && <ButtonTertiary
      onClick={props.onClick}
      fluid
      label={props.artist.name}
    />}
    {!props.selected && <ButtonSecondary
      onClick={props.onClick}
      fluid
      label={props.artist.name}
    />}
  </div>;
};

export default SelectableArtist;